import { API_ADMIN_URL, API_TRAVELS_URL, API_B2B_ADMIN_BASE_URL, APP_ENV, DEV_ENV, API_B2B_BASE_URL } from "../app.config";
import { isValid } from "./utilities";

const URL_STORAGE_KEY = 'api_base_urls';

const isDevEnv = APP_ENV === DEV_ENV;

// Function to safely get server URL
const getServerUrl = (urlType, fallbackUrl) => {
    try {
        // In development, always use the fallback URLs
        if (isDevEnv) {
            return fallbackUrl;
        }

        let returnUrl = fallbackUrl;
        if (isValid(global.serverUrl) && isValid(global.serverUrl[urlType])) {
            returnUrl = global.serverUrl[urlType];
        }
        return returnUrl;
    } catch (error) {
        console.error(`Error getting ${urlType} server URL:`, error);
        return fallbackUrl;
    }
};

// Get base URLs with fallbacks
let API_BASE_URL = getServerUrl('travels_server_url', API_TRAVELS_URL);
let API_ADMIN_BASE_URL = getServerUrl('admin_server_url', API_ADMIN_URL);

// Check if we have stored URLs (skip in development)
if (!isDevEnv) {
    const storedUrls = localStorage.getItem(URL_STORAGE_KEY);
    if (storedUrls) {
        const { travelsUrl, adminBaseUrl } = JSON.parse(storedUrls);
        if (travelsUrl && adminBaseUrl) {
            API_BASE_URL = travelsUrl;
            API_ADMIN_BASE_URL = adminBaseUrl;
        }
    }
}

// Function to update URLs when serverUrl changes
export const updateUrls = () => {
    const newBaseUrl = getServerUrl('travels_server_url', API_TRAVELS_URL);
    const newAdminBaseUrl = getServerUrl('admin_server_url', API_ADMIN_URL);

    // Only update if the URLs have actually changed
    if (newBaseUrl !== API_BASE_URL || newAdminBaseUrl !== API_ADMIN_BASE_URL) {
        API_BASE_URL = newBaseUrl;
        API_ADMIN_BASE_URL = newAdminBaseUrl;

        // Store the new URLs in localStorage (skip in development)
        if (!isDevEnv) {
            localStorage.setItem(URL_STORAGE_KEY, JSON.stringify({
                travelsUrl: API_BASE_URL,
                adminBaseUrl: API_ADMIN_BASE_URL
            }));
        }
    }
};

/**
 * URL's related to location data
 */
export const USER_LOGIN_URL = `${API_BASE_URL}/api/agentLogin`;

export const GET_TRACKING_APP_URL = `${API_BASE_URL}/api/getTrackingApp`;

export const GET_OTA_AVAILABLE_ROUTES_URL = `${API_BASE_URL}/api/getOtaAvailableRoutesUrl`;

/**
 * URL's related to Dashboard
 */

export const GET_DASHBOARD_DATA_URL = `${API_ADMIN_BASE_URL}/api/getInspectData`;

/**
 * URL 's related to origins
 */

export const GET_ORIGIN_CITIES_URL = `${API_BASE_URL}/api/originCities`;
export const GET_DESTINATION_CITIES_URL = `${API_BASE_URL}/api/destinationCities`;
export const GET_STANDARD_ORIGINS_URL = `${API_BASE_URL}/api/standardOrigins`;
export const GET_STANDARD_DESTINATIONS_URL = `${API_BASE_URL}/api/standardDestinations`;

export const FETCH_SCHEDULES_URL = `${API_BASE_URL}/api/schedules`;

export const FETCH_SEAT_LAYOUT_URL = `${API_BASE_URL}/api/seats`;

export const BOOK_TICKET_URL = `${API_BASE_URL}/api/bookAgentTicket`;
export const CHANGE_TICKET_URL = `${API_BASE_URL}/api/changeTicket`;
export const TRANSFER_CHART_TO_NEW_TRIP_URL = `${API_BASE_URL}/api/transferChartToNewTrip`;
export const CHART_TRANSFER_MAPPING_DETAILS_URL = `${API_BASE_URL}/api/getChartTransferMappingDetails`;

export const BLOCK_TICKET_URL = `${API_BASE_URL}/api/blockAgentTicket`;

// UPI booking (Razorpay partner model - no payment gateway redirect)
export const CREATE_UPI_BOOKING_URL = `${API_BASE_URL}/api/createUpiBooking`;
export const GET_UPI_BOOKING_STATUS_URL = `${API_BASE_URL}/api/getUpiBookingStatus`;
export const GET_UPI_COLLECTION_AMOUNT_URL = `${API_BASE_URL}/api/getUpiCollectionAmount`;
// Razorpay OAuth - returns either {authorized:true} or {url} to start consent
export const RAZORPAY_OAUTH_URL = `${API_BASE_URL}/api/razorpayOAuthUrl`;
// UPI permission OTP - gates cancel/bus-cancel/refund of UPI booked tickets
export const SEND_UPI_PERMISSION_OTP_URL = `${API_BASE_URL}/api/sendUpiPermissionOtp`;
export const VERIFY_UPI_PERMISSION_OTP_URL = `${API_BASE_URL}/api/verifyUpiPermissionOtp`;
// UPI wallet recharge for prepaid agents - shares the booking endpoints (paymentFor flag)
export const CREATE_UPI_RECHARGE_URL = `${API_BASE_URL}/api/createUpiBooking`;
export const GET_UPI_RECHARGE_STATUS_URL = `${API_BASE_URL}/api/getUpiBookingStatus`;
export const GET_AGENT_BALANCE_URL = `${API_BASE_URL}/api/getAgentBalance`;

export const GET_PASSENGER_DETAILS_BY_PHONE_NUMBER_URL = `${API_BASE_URL}/api/getPassengerDetailsByPhoneNumber`;

export const GET_ROUTES_BY_SCHEDULE_ID_URL = `${API_ADMIN_BASE_URL}/api/getRoutesByScheduleId`;
export const RE_ACTIVATE_TRIP_ROUTE_BY_TRIP_ID= `${API_ADMIN_BASE_URL}/api/reActivateTripRoutesByTripId`;
export const GET_TRAVELLER_INFO_TICKETID_AND_SEAT_NUMBER_URL = `${API_BASE_URL}/api/getTravellerByTicketIdAndSeatNumber`;
export const GET_ALL_TICKET_DETAILS_URL=`${API_BASE_URL}/api/getAllRoutesByTripId`;
export const SEND_BUS_CANCELLATION_EMAIL_URL = `${API_BASE_URL}/api/sendBusCancellationMailToAgent`;
export const BLOCK_ALL_AVAILABLE_SEATS_OF_TRIP = `${API_BASE_URL}/api/blockAllAvailableSeatsByTripId`;
export const CHANGE_PASSWORD_URL = `${API_BASE_URL}/api/changePassword`;
export const NOTIFICATION_DELAY_BUS_URL = `${API_BASE_URL}/api/notifications/delayBus`;
export const NOTIFICATION_CANCEL_BUS_URL = `${API_BASE_URL}/api/notifications/delayBus`;
export const SEND_CANCELLATION_NOTIFICATION_URL = `${API_BASE_URL}/api/notifications/cancelBus`;
export const GET_TICKET_BY_PNR_URL = `${API_BASE_URL}/api/getTicketByPNR`;
export const GET_TICKET_BY_ID_URL = `${API_BASE_URL}/api/getTicketById`;
export const GET_TICKET_PNR_BY_ID_URL = `${API_BASE_URL}/api/getTicketPNRById`;
export const CANCEL_TICKET_URL = `${API_BASE_URL}/api/cancelTicket`;
export const UPDATE_TICKET_URL = `${API_BASE_URL}/api/updateTicket`;
export const TRIP_SHEET_URL = `${API_BASE_URL}/api/reports/tripSheet`;
export const FETCH_CANCELLED_TRIP_SHEET_URL = `${API_BASE_URL}/api/reports/getCancelledSeatsByTripId`;
export const GET_NOT_BOARDED_SEATS_URL = `${API_BASE_URL}/api/reports/getNotBoardedSeats`;
export const GET_REFUND_ARN_BY_ORDER_ID = `${API_BASE_URL}/api/getRefundARN`;
export const ISSUE_PG_REFUND_URL = `${API_BASE_URL}/api/issuePGRefund`;
export const CONFIRM_PG_TICKET_URL = `${API_BASE_URL}/api/confirmPGTicket`;
export const FETCH_PG_TRANSACTION_LOGS_URL = `${API_BASE_URL}/api/fetchPGTransactionLogs`;

export const BOOKING_SHEET_URL = `${API_BASE_URL}/api/reports/bookedSheet`;
export const BOOKING_PREPAID_OTA_SHEET_URL = `/api/reports/bookedSheet`;
export const SMS_REPORT_SHEET_URL = `${API_BASE_URL}/api/reports/getsmsMessages`;
export const GET_TICKETS_BOOKED_AFTER_TRIP_CLOSE_POINT_URL = `${API_BASE_URL}/api/reports/getTicketsBookedAfterTripClosePoint`;
export const GET_SETTLEMENT_REPORT_URL = `${API_BASE_URL}/api/reports/getSettlementReport`;
export const SALES_SHEET_URL = `${API_BASE_URL}/api/reports/salesSheet`;
export const MASTER_AGENT_SALES_SHEET_URL = `${API_BASE_URL}/api/reports/masterAgentSalesSheet`;
export const MASTER_TRIP_SHEET_URL = `${API_BASE_URL}/api/reports/masterTripSheet`;
export const PASSENGER_INFO_SHEET_URL = `${API_BASE_URL}/api/reports/passengerInfoSheet`;
export const TICKET_SEARCH_URL = `${API_BASE_URL}/api/reports/ticketSearch`;
export const SHARED_TRIP_SALES_URL = `${API_BASE_URL}/api/reports/sharedTripSales`;
export const DASHBOARD_OCCUPANCY_URL = `${API_BASE_URL}/api/reports/getOccupancyByTravelsId`;
export const RELEASE_SEATS_URL = `${API_BASE_URL}/api/releaseSeats`;
export const BLOCK_BY_ADMIN_SEATS_URL = `${API_BASE_URL}/api/adminBlockSeats`;
export const GET_UNIQUE_ACTIVE_ROUTES_URL = `${API_ADMIN_BASE_URL}/api/getUniqueActiveRoutesByOperatorCode`;
export const UPDATE_ROUTE_PRIORITY_URL = `${API_ADMIN_BASE_URL}/api/updateRoutePriority`;

export const GET_DEMAND_DATA_SHEET_URL = `${API_ADMIN_BASE_URL}/api/reports/fetchDemandDataSheet`;
export const GET_GST_FILING_TICKETS_URL = `${API_BASE_URL}/api/reports/getGstFilingTickets`;
export const GET_SEAT_SHARING_REPORT_URL = `${API_BASE_URL}/api/reports/getSeatSharingReport`;

export const OVER_RIDE_PENALITY_URL = `${API_BASE_URL}/api/overridePenalty`;

export const GET_TRIPS_BY_BOOKING_DATE_URL = `${API_BASE_URL}/api/getTripsByBookedDateRange`;
export const GET_TRIPS_BY_START_DATE_URL = `${API_BASE_URL}/api/getTripsByStartDateRange`;
export const BLOCK_AVAILABLE_SEATS_URL = `${API_BASE_URL}/api/blockAvailableSeats`;
export const SET_SEAT_GENDER_URL = `${API_BASE_URL}/api/setSeatGender`;
export const BLOCKED_SHEET_URL = `${API_BASE_URL}/api/reports/blockedSheet`;
export const RESCHEDULED_TICKET_REPORT_URL = `${API_BASE_URL}/api/reports/rescheduledTicketReport`;
export const PERFORMANCE_URL = `${API_BASE_URL}/api/reports/performance`;
export const TRANSACTION_SHEET_URL = `${API_BASE_URL}/api/reports/transactionSheet`;
export const CANCEL_TICKET_SEARCH_URL = `${API_BASE_URL}/api/reports/cancelticketsearch`;
export const FETCH_AGENTS_LEDGER_URL = `${API_BASE_URL}/api/reports/getAgentsLedger`;
export const FETCH_TRANSACTIONS_BY_PNR_URL = `${API_ADMIN_BASE_URL}/api/ticketTransactionOnAgent`;
export const FETCH_POST_PAID_AGENT_UNPAID_TICKETS_URL = `${API_ADMIN_BASE_URL}/api/getPostPaidAgentUnpaidTickets`;

export const ABANDONED_TRANSACTION_SHEET_URL = `${API_BASE_URL}/api/reports/abandonedTransactionsSheet`;
export const WEB_TICKET_SALES_SHEET_URL = `${API_BASE_URL}/api/reports/webTicketSales`;

export const CREATE_TRIP_EXPENSE_URL = `${API_BASE_URL}/api/createTripExpense`;
export const GET_TRIP_EXPENSE_URL = `${API_BASE_URL}/api/getExpenseByTripId`;
export const UPDATE_TRIP_EXPENSE_URL = `${API_BASE_URL}/api/updateTripExpense`;
export const GET_EXPENSE_CONFIG_URL = `${API_BASE_URL}/api/getExpenseConfigByOperatorCode`;
export const GET_EXPENSE_TYPES_URL = `${API_ADMIN_BASE_URL}/api/getExpenseTypes`;
export const GET_EXPENSE_CONFIG_BY_OPERATOR_CODE_URL = `${API_ADMIN_BASE_URL}/api/getExpenseConfigByOperatorCode`;
export const SAVE_EXPENSE_CONFIG_URL = `${API_ADMIN_BASE_URL}/api/saveExpenseConfig`;

export const SEND_PAYMENT_LINK_URL = `${API_BASE_URL}/api/sendPaymentLinkByPnr`;

export const GET_BUS_OPERATORS_URL = `${API_ADMIN_BASE_URL}/api/getActiveTravels`;
export const CREATE_TRAVEL_URL = `${API_B2B_ADMIN_BASE_URL}/api/createTravel`;
export const UPDATE_TRAVEL_URL = `${API_B2B_ADMIN_BASE_URL}/api/updateTravel`;
export const GET_TRAVEL_DETAILS_BY_CREATED_BY_URL = `${API_B2B_ADMIN_BASE_URL}/api/getTravelDetailsByCreatedBy`;
export const FIND_SIMILAR_TRAVELS_URL = `${API_B2B_ADMIN_BASE_URL}/api/findSimilarTravels`;
export const GET_TRAVELS_DETAILS_BY_OPERATOR_CODE_URL =`${API_ADMIN_BASE_URL}/api/getTravelsDetailsByOperatorCode`;
export const UPDATE_TRAVEL_CONFIG_URL = `${API_ADMIN_BASE_URL}/api/updateTravelConfig`;
export const UPDATE_B2B_TRAVEL_CONFIG_URL = `${API_B2B_ADMIN_BASE_URL}/api/updateTravelConfig`;
export const GET_TRAVELS_DETAILS_FOR_CONFIG_URL = `${API_BASE_URL}/api/getTravelsDetailsByOperatorCode`;
export const GET_DEFAULT_OPERATOR_CONFIG_URL = `${API_ADMIN_BASE_URL}/api/getDefaultOperatorConfig`;
export const GET_RESERVATION_DETAILS_BY_OPERATOR_CODE_URL = `${API_ADMIN_BASE_URL}/api/getRersevationDetailsByOperatorCode`;
export const UPDATE_RESERVATION_DETAILS_BY_OPERATOR_CODE_URL = `${API_ADMIN_BASE_URL}/api/updateReservationDetailsByOperatorCode`;
export const GET_SIGNED_WEB_IMAGE_UPLOAD_URL = `${API_BASE_URL}/api/getSignedUploadUrls`;
export const DELETE_WEB_IMAGE_FROM_BUCKET_URL = `${API_BASE_URL}/api/deleteWebImageFromBucket`;
export const GET_OPERATOR_WEB_CONFIG_URL = `${API_B2B_BASE_URL}/api/getWebConfigDataByOperatorCode`;
export const UPDATE_OPERATOR_WEB_CONFIG_COLORS_URL = `${API_B2B_ADMIN_BASE_URL}/api/updateWebConfigColors`;
export const UPDATE_LOGOS_IN_TRAVELS_CONFIG_URL = `${API_ADMIN_BASE_URL}/api/updateLogosInTravelsConfig`;
export const UPDATE_WEB_ACTION_MAPPING_URL = `${API_B2B_ADMIN_BASE_URL}/api/updateWebActionMapping`;
export const UPDATE_TRIP_ROUTE_TIMINGS_URL = `${API_ADMIN_BASE_URL}/api/updateTripTimeByTripId`;
export const GET_TRAVELS_DETAILS_FOR_DAFIDY_PREPAID_OTA_URL = `/api/getTravelsDetailsByOperatorCode`;

//agents portal colours
export const GET_AGENT_COLOURS_URL = `${API_ADMIN_BASE_URL}/api/getAgentPortolColorsByOperatorCode`;
export const UPDATE_AGENT_COLOURS_URL = `${API_ADMIN_BASE_URL}/api/update`;
export const CREATE_AGENT_COLOURS_URL = `${API_ADMIN_BASE_URL}/api/create`;
export const GET_DEFAULT_THEME_COLORS_URL = `${API_ADMIN_BASE_URL}/api/getDefaultThemeColors`;
export const GET_AGENT_COLOUR_THEMES_URL = `${API_ADMIN_BASE_URL}/api/getAllThemeColors`;
export const CREATE_THEME_COLORS_URL = `${API_ADMIN_BASE_URL}/api/createThemeColors`;
export const UPDATE_THEME_COLORS_URL = `${API_ADMIN_BASE_URL}/api/updateThemeColors`;

//redbus cities
export const GET_REDBUS_CITY_LIST_URL = `${API_ADMIN_BASE_URL}/api/getRedbusCityList`;
export const UPDATE_REDBUS_CITY_ALIAS_URL = `${API_ADMIN_BASE_URL}/api/updateRedbusCityAlias`;

// Get vechicle numbers
export const GET_VECHICLES_URL = `${API_ADMIN_BASE_URL}/api/vechicleInfo`;
export const GET_TRIP_ROUTES_BY_SCHEDULE_ID_AND_DATE_URL = `${API_ADMIN_BASE_URL}/api/getTripRoutesByScheduleAndDate`;
export const UPDATE_FARE_FOR_TRIP_ROUTES_URL = `${API_ADMIN_BASE_URL}/api/updateFareForTripRoutes`;
export const UPDATE_FARE_FOR_SEAT_AND_ROUTE_SPECIFIC_URL = `${API_ADMIN_BASE_URL}/api/updateFareForSeatAndRouteSpecific`;
export const UPDATE_TRIP_ROUTES_FARE_TYPE_URL = `${API_ADMIN_BASE_URL}/api/updateTripRoutesFareType`;
export const UPDATE_TRIPS_URL = `${API_ADMIN_BASE_URL}/api/updateTrips`;
export const UPDATE_TRIP_VECHICLE_PHONE_NO_URL = `${API_ADMIN_BASE_URL}/api/updateTripVechiclePhoneNo`;
export const BULK_UPDATE_TRIP_VEHICLE_INFO_URL = `${API_ADMIN_BASE_URL}/api/bulkUpdateTripVehicleInfo`;
export const UPDATE_VEHICLES_URL = `${API_ADMIN_BASE_URL}/api/updateScheduleVechiclePhoneNo`;
export const CREATE_VEHICLE_URL = `${API_ADMIN_BASE_URL}/api/createVechicle`;
export const DELETE_VEHICLE_URL = `${API_ADMIN_BASE_URL}/api/deleteVechicle`;

//Agents urls
export const GET_AGENTS_URL = `${API_ADMIN_BASE_URL}/api/getAgents`;
export const GET_AGENTS_TRANSACTIONS_URL = `${API_ADMIN_BASE_URL}/api/getAgentTransactionsByOperatorCode`;
export const CREATE_AGENT_TRANSACTION_URL = `${API_ADMIN_BASE_URL}/api/createAgentTransaction`;
export const UPDATE_AGENT_TYPE_URL = `${API_ADMIN_BASE_URL}/api/updatePostPaidAgent`;
export const GET_AGENT_PRIVILEGES_URL = `${API_ADMIN_BASE_URL}/api/getAgentPrivileges`;
export const GET_OPERATOR_PRIVILEGE_ACTIONS_URL = `${API_ADMIN_BASE_URL}/api/getOperatorPrivilegeActions`;
export const INSERT_OPERATOR_PRIVILEGE_ACTION_URL = `${API_ADMIN_BASE_URL}/api/insertOperatorPrivilegeAction`;
export const DELETE_OPERATOR_PRIVILEGE_ACTION_URL = `${API_ADMIN_BASE_URL}/api/deleteOperatorPrivilegeAction`;
export const GET_AGENT_NAMES_BY_OPERATOR_CODE_URL = `${API_ADMIN_BASE_URL}/api/getAgentNamesByOperatorCode`;
export const GET_OPERATOR_MAX_DISCOUNT_PRIVILEGE_URL = `${API_ADMIN_BASE_URL}/api/getOperatorMaxDiscountPrivilege`;
export const UPSERT_OPERATOR_MAX_DISCOUNT_PRIVILEGE_URL = `${API_ADMIN_BASE_URL}/api/upsertOperatorMaxDiscountPrivilege`;

export const UPDATE_AGENT_TRANSACTION_STATUS_URL = `${API_ADMIN_BASE_URL}/api/updateAgentTransaction`;
export const GET_AGENTS_BY_OPERATOR_CODE_URL = `${API_BASE_URL}/api/getAgentsByOperatorCode`;
export const GET_PREPAID_OTA_ACCOUNT_URL = `/api/getPrepaidOTAAccountData`;
export const GET_AGENT_UPDATE_LOGS_BY_ID_URL = `${API_ADMIN_BASE_URL}/api/getAgentUpdateLogsById`;
export const GET_SCHEDULE_UPDATE_LOGS_BY_ID_URL = `${API_ADMIN_BASE_URL}/api/getScheduleUpdateLogsById`;

//Driver urls
export const GET_DRIVERS_URL = `${API_ADMIN_BASE_URL}/api/getDriverById`;
export const CREATE_DRIVER_URL = `${API_B2B_ADMIN_BASE_URL}/api/insertDriversManagement`
export const UPDATE_DRIVER_URL = `${API_B2B_ADMIN_BASE_URL}/api/updateFromDriversManagement`;
export const DELETE_DRIVER_URL = `${API_B2B_ADMIN_BASE_URL}/api/deleteFromDriversManagement`;
export const GET_DRIVER_MANAGEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/getDriverManagementByOperator`;

//QBCC management urls
export const GET_QBCC_MANAGEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/getTravelManagements`;
export const CREATE_QBCC_MANAGEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/createtravelmanagement`;
export const UPDATE_QBCC_MANAGEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/updatetravelmanagement`;
export const DELETE_QBCC_MANAGEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/deletetravelmanagement`;

//Settlement urls
export const LIST_FINANCIAL_YEARS_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/financialYears`;
export const LIST_SETTLEMENT_OPENING_BALANCES_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/openingBalances`;
export const SET_SETTLEMENT_OPENING_BALANCE_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/setOpeningBalance`;
export const CLEAR_SETTLEMENT_OPENING_BALANCE_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/clearOpeningBalance`;
export const SETTLEMENT_WORKFLOW_DATA_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/workflowData`;
export const CREATE_SETTLEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/create`;
export const UPDATE_SETTLEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/update`;
export const LIST_SETTLEMENTS_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/list`;
export const GET_SETTLEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/get`;
export const APPROVE_SETTLEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/approve`;
export const CANCEL_SETTLEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/cancel`;
export const DELETE_SETTLEMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/delete`;
export const RECORD_SETTLEMENT_PAYMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/recordPayment`;
export const MODIFY_SETTLEMENT_PAYMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/modifyPayment`;
export const ALLOCATE_SETTLEMENT_ADVANCE_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/allocateAdvance`;
export const UNALLOCATE_SETTLEMENT_PAYMENT_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/unallocatePayment`;
export const LIST_SETTLEMENT_PAYMENTS_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/listPayments`;
// Billing/settlements go through admin_manager_server, which proxies to Console.
export const FETCH_OPERATOR_DOCUMENTS_URL = `${API_ADMIN_BASE_URL}/api/console/fetchDocuments`;
export const FETCH_OPERATOR_BILLING_URL = `${API_ADMIN_BASE_URL}/api/console/fetchBilling`;
export const LIST_UNALLOCATED_ADVANCES_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/listUnallocatedAdvances`;
export const GET_ADVANCE_BALANCE_URL = `${API_B2B_ADMIN_BASE_URL}/api/settlement/getAdvanceBalance`;

//Staff urls
export const GET_STAFF_TYPES_URL = `${API_ADMIN_BASE_URL}/api/getStaffTypes`;
export const GET_STAFF_URL = `${API_ADMIN_BASE_URL}/api/getStaff`;
export const CREATE_STAFF_URL = `${API_ADMIN_BASE_URL}/api/createStaff`;
export const DELETE_STAFF_URL = `${API_ADMIN_BASE_URL}/api/deleteStaffById`;
export const UPDATE_STAFF_URL = `${API_ADMIN_BASE_URL}/api/updateStaff`;
export const SEARCH_STAFF_OPERATOR_URL = `${API_ADMIN_BASE_URL}/api/searchStaffOperator`;

// Otp urls
export const VERIFY_OTP_URL = `${API_BASE_URL}/api/otp/verifyPNOTP`;

//Trip related urls
export const FETCH_MASTER_CITIES_URL = `${API_ADMIN_BASE_URL}/api/getMasterCities`;
export const GET_ADMIN_SCHEDULES_URL = `${API_ADMIN_BASE_URL}/api/getSchedules`;
export const GET_GOOGLE_DISTANCE_MATRIX_URL = `${API_ADMIN_BASE_URL}/api/getDistanceDataBetweenCities`;
export const GET_BUS_URL = `${API_ADMIN_BASE_URL}/api/getBuses`;
export const CLONE_BUS_URL = `${API_ADMIN_BASE_URL}/api/cloneBus`;
export const VALIDATE_SEAT_URL = `${API_ADMIN_BASE_URL}/api/validateSeatLayout`
export const CREATE_TRIP_DATA_URL = `${API_ADMIN_BASE_URL}/api/createScheduleByAgent`;
export const UPDATE_TRIP_DATA_URL = `${API_ADMIN_BASE_URL}/api/updateScheduleByAgent`;
export const GET_SCHEDULE_TRIP_CITY_URL = `${API_ADMIN_BASE_URL}/api/getScheduleTripCity`;
export const GET_ADDRESS_LOCATIONS_URL = `${API_ADMIN_BASE_URL}/api/getAddressLocations`;
export const INSERT_TRIP_STOPS_URL = `${API_ADMIN_BASE_URL}/api/insertTripStops`;
export const GET_SCHEDULE_WITH_STOPS_URL = `${API_ADMIN_BASE_URL}/api/getScheduleWithStops`;
export const INSERT_SCHEDULE_BY_STOPS_URL = `${API_ADMIN_BASE_URL}/api/insertScheduleByStops`;
export const GET_SCHEDULES_BY_ID_FOR_DATES_URL = `${API_ADMIN_BASE_URL}/api/getSchedulesByIdForDate`;
export const ACTIVATE_SCHEDULES_URL = `${API_ADMIN_BASE_URL}/api/activateTrips`;
export const BLOCK_SCHEDULES_URL = `${API_ADMIN_BASE_URL}/api/blockTrips`;
export const VALIDATE_TRIP_URL =`${API_ADMIN_BASE_URL}/api/validateSchedule`;
export const GET_DEMAND_DAYS_URL = `${API_ADMIN_BASE_URL}/api/fetchDemandDays`;
export const GET_SEAT_GROUPS_URL = `${API_ADMIN_BASE_URL}/api/getSeatGroups`;
export const GET_SEAT_TYPES_URL = `${API_ADMIN_BASE_URL}/api/getSeatTypes`;
export const CREATE_AGENT_BUS_URL = `${API_ADMIN_BASE_URL}/api/createAgentBus`;
export const UPDATE_AGENT_BUS_URL = `${API_ADMIN_BASE_URL}/api/updateAgentBus`;
export const DELETE_AGENT_BUS_URL = `${API_ADMIN_BASE_URL}/api/deleteBusById`;
export const GET_COACH_TYPE_URL = `${API_ADMIN_BASE_URL}/api/getCoachType`;
export const GET_BUS_TEMPLATE_URL = `${API_ADMIN_BASE_URL}/api/getBusTemplate`;
export const GET_SEAT_LAYOUT_BY_TEMPLATE_ID_URL = `${API_ADMIN_BASE_URL}/api/getSeatLayoutByTemplateId`;
export const CREATE_COACH_TYPE_URL = `${API_ADMIN_BASE_URL}/api/createCoachType`;

export const REMOVE_SCHEDULES_URL = `${API_ADMIN_BASE_URL}/api/removeSchedule`;

export const GET_SEAT_LAYOUT_BY_BUS_ID_URL = `${API_BASE_URL}/api/getSeatLayoutByBusId`;
export const CREATE_ADDRESS_URL = `${API_ADMIN_BASE_URL}/api/createLocation`;
export const UPDATE_ADDRESS_URL = `${API_ADMIN_BASE_URL}/api/updateLocation`;

export const GET_DISTANCE_BETWEEN_TWO_CITIES_URL = `${API_ADMIN_BASE_URL}/api/getDistanceDataBetweenCities`;

export const GET_LAT_LNG_OF_ADDRESS_URL = `${API_ADMIN_BASE_URL}/api/getLatLngofAddress`;
export const FETCH_ACTIVE_BOOKINGS_URL = `${API_BASE_URL}/api/reports/getActiveBookings`;
export const FETCH_SERVICE_COUNT_REPORT_URL = `${API_BASE_URL}/api/reports/getServiceCountReport`;
export const FETCH_OCCUPANCY_REPORT_URL = `${API_BASE_URL}/api/reports/getOccupancyReport`;
export const FETCH_BUS_SERVICE_COLLECTION_REPORT_URL = `${API_BASE_URL}/api/reports/getBusServiceCollectionReport`;


export const GET_STANDARD_STOPS__URL = `${API_ADMIN_BASE_URL}/api/getStandardAddresses`;
export const CREATE_ADDRESS_LOCATION_URL = `${API_ADMIN_BASE_URL}/api/createLocation`;
export const UPDATE_ADDRESS_LOCATION_URL = `${API_ADMIN_BASE_URL}/api/updateLocation`;
export const DELETE_ADDRESS_LOCATION_URL = `${API_ADMIN_BASE_URL}/api/deleteLocationById`;
export const GET_BRANCH_OFFICES_URL = `${API_ADMIN_BASE_URL}/api/getBranchOfficesByOperatorCode`;

export const UPDATE_STOP_TIMINGS_URL = `${API_ADMIN_BASE_URL}/api/updateStopTimings`;
export const GET_PICKUP_LOCATION_BY_TRIP_ID_URL = `${API_BASE_URL}/api/getPickupLocationByTripId`;
export const GET_DROP_LOCATION_BY_TRIP_ID_URL = `${API_BASE_URL}/api/getDropLocationByTripId`;
export const GET_AMENITIES_FOR_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/getAmenitiesForSchedule`;
export const FETCH_AMENITIES_URL = `${API_ADMIN_BASE_URL}/api/fetchAmenities`;
export const ADD_AMENITIES_TO_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/addAmenitiesToSchedule`
export const GET_SCHEDULE_COMMISSION_URL = `${API_ADMIN_BASE_URL}/api/getScheduleCommission`;
export const UPDATE_SCHEDULE_COMMISSION_URL = `${API_ADMIN_BASE_URL}/api/updateScheduleCommission`;
export const TRIP_ACTIVATION_MAIL_OTAS_URL = `${API_BASE_URL}/api/sendTripActivateEmailToOtas`;
export const SET_EXCEPTIONAL_REFUND_BY_TICKET_URL = `${API_BASE_URL}/api/setExceptionalRefund`;

// Trip sheet permissions 

export const GET_SCHEDULES_WITH_TRIP_SHEET_PERMISSION_URL=`${API_ADMIN_BASE_URL}/api/getSchedulesWithTripSheetPermission`;
export const INSERT_TRIP_SHEET_PERMISSION_URL=`${API_ADMIN_BASE_URL}/api/insertTripSheetPermission`;
export const UPDATE_TRIP_SHEET_PERMISSION_URL=`${API_ADMIN_BASE_URL}/api/updateTripSheetPermission`;
export const DELETE_TRIP_SHEET_PERMISSION_URL=`${API_ADMIN_BASE_URL}/api/deleteTripSheetPermission`;
export const BLUK_UPDATE_TRIP_SHEET_PERMISSION_URL=`${API_ADMIN_BASE_URL}/api/blukUpdateTripSheetPermission`;

// release all blocked seats

export const RELEASE_ALL_BLOCKED_SEATS_URL = `${API_BASE_URL}/api/releaseBlockedSeatsByTripId`;

export const GET_SCHEDULE_STOPS_BY_TRIP_ID_URL = `${API_ADMIN_BASE_URL}/api/getScheduleStopsByTripIdWithCities`;

export const RESET_TO_DEFAULT_TIMINGS_URL = `${API_ADMIN_BASE_URL}/api/resetToDefaultTimings`;

export const GET_TICKET_ALERT_CONTENT_FOR_RESET_STOPS_URL = `${API_ADMIN_BASE_URL}/api/getTicketAlertConentForResetStops`;

export const UPDATE_STOP_TIMING_OF_TRIP_URL = `${API_ADMIN_BASE_URL}/api/updateStopTimingsOfTrip`;

export const GET_STOP_BOOKING_CONFLICTS_FOR_FUTURE_DATES_URL = `${API_ADMIN_BASE_URL}/api/getStopBookingConflictsForFutureDates`;

export const FETCH_LOGS_TRIP_URL = `${API_ADMIN_BASE_URL}/api/fetchLogsByTripId`;
export const FETCH_TICKET_LOGS_TRIP_URL = `${API_ADMIN_BASE_URL}/api/fetchTicketLogsByTripId`;

export const ACTIVATE_REDBUS_CITY_PAIR_URL = `${API_ADMIN_BASE_URL}/api/activateRedbusCityPair`;

export const SEND_TRACKING_NOTIFICATION_BY_TICKET_ID_URL = `${API_BASE_URL}/api/sendTrackingNotification`;
export const SEND_TRACKING_NOTIFICATION_BY_TRIP_ID_URL = `${API_BASE_URL}/api/sendNotificationByTripIds`;
export const GET_TRACKING_INFO_BY_TRIP_ID_URL = `${API_BASE_URL}/api/getTrackingInfoByTripId`;
export const GET_STOP_ARRIVAL_URL = `${API_BASE_URL}/api/getStopArrival`;

//schedule related urls

export const GET_DROP_LOCATION_BY_SCHEDULE_ID_URL = `${API_ADMIN_BASE_URL}/api/getDropLocationsByScheduleId`;
export const GET_PICKUP_LOCATION_BY_SCHEDULE_ID_URL = `${API_ADMIN_BASE_URL}/api/getPickupLocationsByScheduleId`;

export const SEND_UPDATED_TICKET_MAIL_URL = `${API_BASE_URL}/api/sendBookedTicket`;
export const SEND_UPDATED_TICKET_SMS_URL = `${API_BASE_URL}/api/sendBookedTicketSms`;

export const UPDATE_TRIP_CUT_ROUTE_URL = `${API_ADMIN_BASE_URL}/api/updateTripCutRouteByDate`;
export const UPDATE_TRIP_BP_CHECK_URL = `${API_ADMIN_BASE_URL}/api/updateTripBpCheckByDate`;

export const FETCH_WORKFLOW_REPORT_URL = `/api/getWorkflowReport`;
export const FETCH_TRANSACTION_COUNT_REPORT_URL = `${API_BASE_URL}/api/reports/getTransactionCountDetails`;
export const FETCH_PRE_PAID_TRANSACTION_COUNT_REPORT_URL = `/api/reports/mavenTransaction`;
export const FETCH_OTA_TRANSACTION_REPORT_URL = `/api/reports/otaTransaction`;

export const FETCH_REVENUE_REPORT_URL = `${API_BASE_URL}/api/reports/revenue`;

export const FETCH_REVENUE_FOR_WEEK_OTA_URL = `${API_BASE_URL}/api/reports/getDashBoardRevenueForOTA`;

export const FETCH_CITY_DETAILS_URL = `${API_ADMIN_BASE_URL}/api/getcitiesDetails`;
export const FETCH_TODAYS_TICKET_COUNT_URL = `${API_ADMIN_BASE_URL}/api/fetchTodaysTicketCount`;

export const UPDATE_CITY_PHONE_NO_URL = `${API_ADMIN_BASE_URL}/api/updateCityPhoneNumber`;

export const UPDATE_BP_AND_DP_URL = `${API_ADMIN_BASE_URL}/api/bulkupdatePickupandDropLocation`;

export const GET_BP_FROM_ADMIN_URL = `${API_ADMIN_BASE_URL}/api/getPickupLocations`;
export const GET_DP_FROM_ADMIN_URL = `${API_ADMIN_BASE_URL}/api/getDropLocations`;

export const UPDATE_BOARDING_POINT_TIME_URL = `${API_ADMIN_BASE_URL}/api/updateBoardingPointTimeById`;

export const UPDATE_DROP_POINT_TIME_URL = `${API_ADMIN_BASE_URL}/api/updateDropPointTimeById`;

export const UPDATE_TRIP_DYNAMIC_PRICING_URL = `${API_ADMIN_BASE_URL}/api/updateTripDynamicPricing`;

export const UPDATE_TRIP_DYNAMIC_FARE_URL = `${API_ADMIN_BASE_URL}/api/updateDynamicFareForTrip`;

export const DELETE_STOPS_URL = `${API_ADMIN_BASE_URL}/api/deleteStops`;

export const ADD_STOPS_URL = `${API_ADMIN_BASE_URL}/api/addStops`;

export const COPY_TRAVELLER_INFO_TO_SEAT_URL = `${API_BASE_URL}/api/copyTravellerInfoSeat`;

export const CLEAR_TRAVELLER_INFO_FROM_SEAT_URL = `${API_BASE_URL}/api/clearSeats`;

export const REGISTER_REDBUS_DP_ABOUT_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/registerRedBusDPAboutSchedule`;

export const DE_REGISTER_REDBUS_DP_ABOUT_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/informRedBusDPAboutScheduleDeRegister`;

export const REGISTER_SCIATIVE_DP_ABOUT_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/registerSciativeDPAboutSchedule`;

export const DE_REGISTER_SCIATIVE_DP_ABOUT_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/informSciativeDPAboutScheduleDeRegister`;

export const CHANGE_SEAT_LAYOUT_URL = `${API_ADMIN_BASE_URL}/api/changeSeatLayout`;

export const INFORM_OTA_FOR_TRIP_CHANGES_URL = `${API_ADMIN_BASE_URL}/api/informOTAforTripChanges`;

export const CLONE_TRIP_URL =`${API_ADMIN_BASE_URL}/api/cloneSchedule`;
export const CREATE_SCHEDULE_BY_STOPS_URL =`${API_ADMIN_BASE_URL}/api/createScheduleByStops`;

export const REFRESH_CACHE_FOR_DROP_POINTS_URL = `${API_BASE_URL}/api/refreshCacheForDropPoints`;
export const REFRESH_CACHE_FOR_BOARDING_POINTS_URL = `${API_BASE_URL}/api/refreshCacheForBoardingPoints`;

export const UPDATE_PHONE_NUMBERS_OF_ADDRESS_BOOK_URL = `${API_ADMIN_BASE_URL}/api/updatePhoneNumbersOfAddressBook`;

export const VERIFY_ADDRESS_BOOK_URL = `${API_ADMIN_BASE_URL}/api/verifyAddressBook`;
export const UPDATE_ADDRESS_BOOK_OFFICE_FLAG_URL = `${API_ADMIN_BASE_URL}/api/updateAddressBookOfficeFlag`;


export const GET_PARTNER_CODE_URL = `${API_ADMIN_BASE_URL}/api/getPartnerDetails`;

export const UPDATE_PARTNER_URL=`${API_ADMIN_BASE_URL}/api/updatePartner`;

export const FETCH_TRACKING_DATA_REPORT_URL = `${API_ADMIN_BASE_URL}/report/getTrackingReportByDate`;

export const UPDATE_SUBSCRIBED_VALUE_URL = `${API_B2B_ADMIN_BASE_URL}/api/changeSubscription`;

export const  IN_ACTIVATE_TRIPS_CREATED_URL = `${API_ADMIN_BASE_URL}/api/inactivateTripsCreated`;

export const ISSUE_AUTOMATIC_REUND_BY_TRAVELLER_URL = `${API_BASE_URL}/api/issueAutomaticRefundByTraveller`;

export const ACTIVATE_IN_OTAS_URL = `${API_ADMIN_BASE_URL}/api/activateInOtas`;

export const ACTIVATE_IN_OTA_BY_ROUTES_URL = `${API_ADMIN_BASE_URL}/api/activateInOTAByRoutes`;


// AGENT ACTIONS 
export const GET_AGENT_ACTIONS_URL = `${API_ADMIN_BASE_URL}/api/getAgentActions`;
export const CREATE_AGENT_PRIVILEGE_URL = `${API_ADMIN_BASE_URL}/api/createAgentPrivilege`;
export const CREATE_AGENT_URL = `${API_ADMIN_BASE_URL}/api/createAgent`;
export const DELETE_AGENT_URL = `${API_ADMIN_BASE_URL}/api/deleteAgentById`;
export const UPDATE_AGENT_URL = `${API_ADMIN_BASE_URL}/api/updateAgent`;
export const UPDATE_AGENT_ACTIVE_STATUS_URL = `${API_ADMIN_BASE_URL}/api/updateAgentActiveStatus`;

export const GET_USER_ACTIONS_URL = `${API_ADMIN_BASE_URL}/api/getUserActions`;
export const INSERT_USER_PRIVILEGE_URL= `${API_ADMIN_BASE_URL}/api/insertUserPrivilege`;
export const DELETE_USER_PRIVILEGE_URL= `${API_ADMIN_BASE_URL}/api/deleteUserPrivilege`;

// SKUs
export const PUSH_USAGE_URL = `${API_BASE_URL}/api/pushBiilingData`;
export const PUSH_SETTLEMENT_USAGE_URL = `${API_BASE_URL}/api/pushSettlementData`;
export const GET_SHIFTED_PASSENGERS_URL = `${API_BASE_URL}/api/getShiftedPassengers`;
export const GET_RELEASED_SEATS_URL = `${API_BASE_URL}/api/getReleasedSeats`;

export const UPDATE_ADVANCE_BOOKING_DAYS_URL = `${API_ADMIN_BASE_URL}/api/updateAdvanceBookingDays`;

export const GET_SERVICES_BY_CITY_URL = `${API_ADMIN_BASE_URL}/api/getServicesByCity`;
export const UPDATE_SERVICE_ACCESS_URL = `${API_ADMIN_BASE_URL}/api/updateServiceAccess`;

// Service sharing
export const GET_ALLOWED_BOOKING_OPERATORS_URL = `${API_ADMIN_BASE_URL}/api/getAllowedBookingOperators`;
export const GET_SCHEDULES_WITH_SHARING_FLAGS_URL = `${API_ADMIN_BASE_URL}/api/getSchedulesWithSharingFlags`;
export const UPDATE_SCHEDULE_SHARING_FLAGS_URL = `${API_ADMIN_BASE_URL}/api/updateScheduleSharingFlags`;
export const GET_SHARING_AGENT_ACTIONS_URL = `${API_BASE_URL}/api/getSharingAgentActions`;
export const GET_BOOKING_PARTNERS_URL = `${API_ADMIN_BASE_URL}/api/getBookingPartners`;
export const UPDATE_ALLOWED_BOOKING_OPERATORS_URL = `${API_ADMIN_BASE_URL}/api/updateAllowedBookingOperators`;
export const SEND_OTA_INTEGRATION_URL = `${API_ADMIN_BASE_URL}/api/sendOTAIntegrationMail`;
export const SEND_SENSEL_INTEGRATION_URL = `${API_BASE_URL}/api/sendSenselIntegrationRequest`;

export const GET_TEMPORARY_CHANGES_BY_MONTH_URL = `${API_ADMIN_BASE_URL}/api/getTemporaryChangedSchedulesByMonth`;

export const GET_STOPS_REMOVED_BY_TRIP_IDS_URL = `${API_ADMIN_BASE_URL}/api/getStopsRemovedByTripIds`;
export const GET_STOPS_ADDED_BY_TRIP_IDS_URL = `${API_ADMIN_BASE_URL}/api/getStopsAddedByTripIds`;

export const GET_SCHEDULE_STOPS_FOR_SCHEDULE_URL = `${API_ADMIN_BASE_URL}/api/getScheduleStopsForSchedule`;
export const RECREATE_SCHEDULE_CITIES_URL = `${API_ADMIN_BASE_URL}/api/reCreateScheduleCities`;
export const GET_SYSTEM_INFO_URL = `${API_ADMIN_BASE_URL}/api/getSystemInfo`;

export const GET_SMS_TEMPLATES_URL = `${API_BASE_URL}/api/getSMSTemplateForNotify`;

export const SEND_SMS_URL = `${API_BASE_URL}/api/sendNotifySms`;

export const UPDATE_TRAVELLER_BOARDED_STATUS_URL = `${API_BASE_URL}/api/updateTravellerBoardedStatus`;

export const GET_BUS_BY_ID_URL = `${API_BASE_URL}/api/buses`;

export const GET_SERVER_URL_BY_USER_NAME_URL = `${API_ADMIN_URL}/api/fetchServerURLByUserName`;

export const GET_ACTIVATED_ROUTES_BY_DATES_AND_SCHEDULE_ID_URL = `${API_ADMIN_BASE_URL}/api/getActivatedRoutesByDatesAndScheduleId`;

export const  REVERT_CANCELLED_TICKET_URL= `${API_BASE_URL}/api/revertCancelledTicket`;

export const VALIDATE_TRIP_ROUTE_FOR_OTA_URL = `${API_BASE_URL}/api/validateTripRouteForOTA`;
export const APPLY_EXCEPTIONAL_REFUND_URL = `${API_BASE_URL}/api/exceptionalRefund`;
export const GET_ALL_ROUTES_BY_DATE_URL = `/api/getAllRoutesByDate`;
export const GET_CANCELLATION_POLICY_BY_OPERATOR_CODE_URL = `${API_ADMIN_BASE_URL}/api/getCancellationPolicyByOperatorCode`;
export const UPDATE_CANCELLATION_POLICY_URL = `${API_ADMIN_BASE_URL}/api/updateCancellationPolicy`;
export const CREATE_CANCELLATION_POLICY_URL = `${API_ADMIN_BASE_URL}/api/createCancellationPolicy`;
export const DELETE_CANCELLATION_POLICY_URL = `${API_ADMIN_BASE_URL}/api/deleteCancellationPolicy`;
export const GET_ACTIVE_OPERATORS_WITH_CONFIGS_URL = `/api/getActiveOperatorsWithConfigs`;
export const GET_ACTIVE_OPERATORS_FOR_SETTLEMENT_URL = `/api/getActiveOperatorsForSettlement`;
export const FETCH_DRIVER_ATTENDANCE_REPORT_URL = `${API_ADMIN_BASE_URL}/reports/getDriverAttendanceReport`;
export const FETCH_DRIVER_SERVICES_REPORT_URL = `${API_ADMIN_BASE_URL}/reports/getDriverServicesReport`;
export const FETCH_EXPENSE_REPORT_URL = `${API_ADMIN_BASE_URL}/reports/getExpenseReport`;

// Stop Analysis Report URLs
export const GET_BOARDING_DROP_STATS_URL = `${API_ADMIN_BASE_URL}/api/getBoardingDropStats`;
export const GET_UNIQUE_SCHEDULES_BY_ORIGIN_DESTINATION_URL = `${API_ADMIN_BASE_URL}/api/getUniqueSchedulesByOriginDestinationAndDateRange`;


 //trips

export const INSERT_TRIP_URL = `${API_ADMIN_BASE_URL}/api/createSchedule`;
export const GET_ROUTES_BY_TRIP_ID_URL = `${API_ADMIN_BASE_URL}/api/getNewRoutesByScheduleId`;
export const GET_SCHEDULE_BY_ID_URL = `${API_ADMIN_BASE_URL}/api/getScheduleById`;
export const CREATE_ROUTES_URL = `${API_ADMIN_BASE_URL}/api/createRoutes`;
export const GET_BOARDING_POINTS_BY_SCHEDULE_ID_URL = `${API_ADMIN_BASE_URL}/api/getPickupLocationsByScheduleId`; //double
export const GET_DROP_POINTS_BY_SCHEDULE_ID_URL = `${API_ADMIN_BASE_URL}/api/getDropLocationsByScheduleId`; //double
export const CREATE_BOARDING_POINTS_URL = `${API_ADMIN_BASE_URL}/api/createPickupLocation`;
export const CREATE_DROP_POINTS_URL = `${API_ADMIN_BASE_URL}/api/createDropLocation`;
export const REGISTER_DP_URL =`${API_ADMIN_BASE_URL}/api/informRedBusDPAboutScheduleRegister`;
export const DE_REGISTER_DP_URL =`${API_ADMIN_BASE_URL}/api/informRedBusDPAboutScheduleDeRegister`; //double
export const DELETE_TRIP_URL = `${API_ADMIN_BASE_URL}/api/deleteScheduleById`;

export const DELETE_ROUTE_BY_ID_URL = `${API_ADMIN_BASE_URL}/api/deleteRouteById`;
export const DELETE_BOARDING_POINT_URL = `${API_ADMIN_BASE_URL}/api/deletePickupLocationById`;
export const UPDATE_BOARDING_POINT_URL = `${API_ADMIN_BASE_URL}/api/updatePickupLocation`;
export const UPDATE_DROP_POINT_URL = `${API_ADMIN_BASE_URL}/api/updateDropLocation`;
export const DELETE_DROP_POINT_URL = `${API_ADMIN_BASE_URL}/api/deleteDropLocationById`;
export const UPDATE_TRIP_URL = `${API_ADMIN_BASE_URL}/api/updateSchedule`;
export const UPDATE_ROUTES_FARE_URL =`${API_ADMIN_BASE_URL}/api/updateRoutes`;
export const INSERT_BOARDING_POINTS_INTO_TEMPLATE_URL = `${API_ADMIN_BASE_URL}/api/saveBoardingPointsInTemplate`;
export const INSERT_DROP_POINTS_INTO_TEMPLATE_URL = `${API_ADMIN_BASE_URL}/api/saveDropPointsInTemplate`;
export const VALIDATE_TICKET_IMPORT_URL = `${API_ADMIN_BASE_URL}/api/validateTicketImport`;
export const BULK_BOOK_IMPORTED_TICKETS_URL = `${API_ADMIN_BASE_URL}/api/bulkBookImportedTickets`;
export const BULK_RELEASE_IMPORTED_TICKETS_URL = `${API_ADMIN_BASE_URL}/api/bulkReleaseImportedTickets`;
